import {
  GetActiveCampaignContactQuery,
  GetCampaignForTexterQuery,
  GetThreadQuery,
  MediaAttachmentInput,
} from "~frontend/__generated__/graphql";

export type Thread = GetThreadQuery["getThread"];
export type CampaignNameAndId = {
  name?: string | null;
  id?: string | null;
};
export type ActiveCampaignContact =
  GetActiveCampaignContactQuery["getCampaignContact"];
export type CampaignForTexter = GetCampaignForTexterQuery["getCampaign"];

export type Message = {
  text: string;
  attachments: MediaAttachmentInput[];
};

export enum TagAppliedBy {
  Manual = "manual",
  ResponseScript = "responseScript",
}

export type UnsavedTag = {
  tagId: string;
  tagGroupId: string | null;
  appliedBy: TagAppliedBy;
};

export function updateUnsavedTagsForNewResponseScriptTags(
  tagAndGroupIds: { tagId: string; tagGroupId: string | null }[],
  unsavedTags: UnsavedTag[],
  contactData: {
    tags: {
      tag: {
        id: string;
      };
    }[];
  }
): UnsavedTag[] {
  // un-select any previous tags that were applied by the response script
  let manualUnsavedTags = unsavedTags.filter(
    t => t.appliedBy !== TagAppliedBy.ResponseScript
  );

  // un-select any unsaved tags that belong to the same group as
  // a tag we're applying
  tagAndGroupIds.forEach(({ tagGroupId }) => {
    if (tagGroupId != null) {
      manualUnsavedTags = manualUnsavedTags.filter(
        t => t.tagGroupId !== tagGroupId
      );
    }
  });

  const existingTagsIds = new Set(
    contactData.tags
      .map(contactTag => contactTag.tag.id)
      .concat(manualUnsavedTags.map(t => t.tagId))
  );

  const newUnsavedTags = tagAndGroupIds
    .filter(({ tagId }) => !existingTagsIds.has(tagId))
    .map(({ tagId, tagGroupId }) => ({
      tagId,
      tagGroupId,
      appliedBy: TagAppliedBy.ResponseScript,
    }));

  return Array.from(manualUnsavedTags.concat(newUnsavedTags));
}
